import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation RateChatNPS($id: ID!, $rating: NPS!) {
    rateChatNPS(id: $id, rating: $rating) {
      id
      npsRating
    }
  }
`);
